var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.ScrollPane},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTop),expression:"showTop"}],class:_vm.$style.indicatorTop}),_c('div',{ref:"container",class:[
      _vm.$style.container,
      _vm.containerClass
    ],style:(Object.assign({}, {padding: _vm.padding,
      overflowY: _vm.disabled ? 'hidden' : undefined},
      (_vm.containerStyle || {}))),on:{"&scroll":function($event){return _vm.update.apply(null, arguments)}}},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBottom),expression:"showBottom"}],class:_vm.$style.indicatorBottom})])}
var staticRenderFns = []

export { render, staticRenderFns }